import { render, staticRenderFns } from "./shift-assignment.vue?vue&type=template&id=29faf7aa&"
import script from "./shift-assignment.vue?vue&type=script&lang=js&"
export * from "./shift-assignment.vue?vue&type=script&lang=js&"
import style0 from "./shift-assignment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "shift-assignment.vue"
export default component.exports